import { useQuery } from "@tanstack/react-query";
import { getFlashDealsToday } from "../services/products.service";
import type { FlashDeal } from "../services/products.service";

export type { FlashDeal, FlashDealProduct } from "../services/products.service";

interface UseFlashDealsOptions {
  currencyRate?: number;
  enabled?: boolean;
}

export function useFlashDeals({
  currencyRate = 1,
  enabled = true,
}: UseFlashDealsOptions = {}) {
  return useQuery<FlashDeal[]>({
    queryKey: ["flash-deals", currencyRate],
    queryFn: () => getFlashDealsToday(currencyRate),
    enabled,
    staleTime: 60 * 1000, // 1 minute – deals are time-sensitive
    gcTime: 5 * 60 * 1000,
    refetchInterval: 60 * 1000, // poll every minute to keep deals fresh
  });
}
